// Copyright (c) 2015, YangtzeSoft Technologies. and Contributors
// MIT License. See license.txt

// provide a namespace
if (!window.yangtze) window.yangtze = {};

yangtze.provide = function (namespace) {
	// docs: create a namespace //
	var nsl = namespace.split(".");
	var parent = window;
	for (var i = 0; i < nsl.length; i++) {
		var n = nsl[i];
		if (!parent[n]) {
			parent[n] = {};
		}
		parent = parent[n];
	}
	return parent;
};

yangtze.provide("locals");
yangtze.provide("yangtze.flags");
yangtze.provide("yangtze.settings");
yangtze.provide("yangtze.utils");
yangtze.provide("yangtze.ui.form");
yangtze.provide("yangtze.modules");
yangtze.provide("yangtze.templates");
yangtze.provide("yangtze.test_data");
yangtze.provide("yangtze.utils");
yangtze.provide("yangtze.model");
yangtze.provide("yangtze.user");
yangtze.provide("yangtze.session");
yangtze.provide("yangtze._messages");
yangtze.provide("locals.DocType");

// for listviews
yangtze.provide("yangtze.listview_settings");
yangtze.provide("yangtze.tour");
yangtze.provide("yangtze.listview_parent_route");

// constants
window.NEWLINE = "\n";
window.TAB = 9;
window.UP_ARROW = 38;
window.DOWN_ARROW = 40;

// proxy for user globals defined in desk.js

// API globals
window.cur_frm = null;
